import React from "react";
import {Link} from "react-router-dom";
import {Button} from "reactstrap";
import {formatIso8601DateTime, humanizeDuration} from "../../utils/functions";

const ActivityItem = (props: any) => {
  if (props === undefined || !props.Cpu) {
    return <></>;
  }

  const crowdedness: number = Math.round(props.Crowdedness * 100);

  return (
    <>
      <tr className="user-activity-row">
        <td className="text-center">
          <Link to={`/logreport/${encodeURIComponent(props.S3Key)}`} target="_blank" rel="noreferrer">
            <Button color="primary" size="sm" className="btn-simple user-activity-btn" data-color={props.color}>
              <i className="fa fa-eye" />
            </Button>
          </Link>
        </td>
        <td>
          <h5 className="user-activity">{formatIso8601DateTime(props.StartTime, props.timezoneOffsetMinutes)}</h5>
        </td>
        <td>
          <h5 className="user-activity">{props.WorldName}</h5>
        </td>
        <td>
          <h5 className="user-activity">{humanizeDuration(props.Duration)}</h5>
        </td>
        <td>
          <h5 className="user-activity">
            {props.Cpu} - {props.Gpu}
          </h5>
        </td>
        <td>
          <h5 className="user-activity-right">{props.GameClientVersion}</h5>
        </td>
        <td>
          <h5 className="user-activity-right">{crowdedness}%</h5>
        </td>
        <td>
          <h5 className="user-activity-right">{props.MaxFps}</h5>
        </td>
        <td>
          <h5 className="user-activity-right">{props.AvgFps}</h5>
        </td>
        <td>
          <h5 className="user-activity-right">{props.Pc1Fps}</h5>
        </td>
      </tr>
    </>
  );
};

export default ActivityItem;
